import { useLocation, useSearchParams } from 'react-router-dom';
import { routeServiceMap, noAutoSelectPaths } from '@/lib/formConfig';

/**
 * useFormContext - Hook for detecting service context from route or URL params
 * 
 * Priority:
 * 1. URL parameter (?service=SEO)
 * 2. Route mapping (/seo → SEO)
 * 3. Default (empty/null)
 */

export const useFormContext = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  // Check URL parameter first
  const serviceParam = searchParams.get('service');
  
  // Check route mapping
  const routeService = routeServiceMap[location.pathname];
  
  // Determine if auto-select should apply
  const shouldAutoSelect = !noAutoSelectPaths.includes(location.pathname);
  
  // Get the detected service (param takes priority)
  const detectedService = serviceParam || (shouldAutoSelect ? routeService : null);
  
  return {
    pathname: location.pathname,
    detectedService,
    shouldAutoSelect: !!detectedService,
    isFromServicePage: !!routeService,
  };
};
